/**
 * URL-hash keys for the packing feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Keys stay colocated with the feature (not centralized) so no cross-feature
 * imports are needed — the same convention as per-feature i18n namespaces.
 * Row-scoped overlays carry the entity id as a hash param (`#remove/5`).
 */
export const PACKING_HASH = {
  // box-detail-page overlays
  /** `#add` — add-container search Dialog. */
  add: 'add',
  /** `#scan` — QrScanDialog (camera). Shared literal across both pages. */
  scan: 'scan',
  /** `#remove/<registrationId>` — remove-registration AlertDialog. */
  remove: 'remove',
  /** `#client-mismatch` — client-mismatch confirm AlertDialog (hybrid: hash
   * drives open, local state holds the transient container-number payload). */
  clientMismatch: 'client-mismatch',
  // packing-listing overlays
  /** `#delete/<id>` — single-box delete confirmation. */
  delete: 'delete',
  /** `#rollback/<id>` — rollback dialog (in_transit → in_shipping). */
  rollback: 'rollback',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type PackingHashKey = (typeof PACKING_HASH)[keyof typeof PACKING_HASH];
